module.exports = __webpack_public_path__ + "img/smallktape.a17825da.jpg";